import { isMobileDevice } from '@superbet-group/web.lib.vue-utilities';

export type HowToOpen = 'inApp' | 'newTab';

export function getPlatformParameter() {
    return isMobileDevice() ? 'web_mobile' : 'web_desktop';
}
